// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"201":"dce27119","640":"e8599af0","869":"70b81651"}[chunkId] + ".css";
};